import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getMiamiStructuredData() {
  const url = "https://restorehair.com/locations/florida/miami/";
  const description =
    "Find out about your hair transplant options in Miami with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("miami", url, description),
    locationPageCrumbs(url, "Miami"),
  ];
}
